import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { setPendingReceiverBank } from "../../../store/slices/receiver-bank-slice";

/**
 * Editable "Receiver Bank" checkbox for the Current Customer tab Gas
 * "Containers On Site" grid (legacy chkReceiverBank → Orders.UpdateIsReceiverBank
 * on GasTrackingNumbers — Gas-only feature). Toggles are buffered in Redux and
 * persisted only on the order Save button, mirroring legacy UpdateContainersOnSite
 * (which saved every checkbox on the whole-page save).
 */
export const ReceiverBankCheckbox = ({ row }: { row: any }) => {
  const trackingNumberId = row?.trackingNumberId;
  const dispatch = useDispatch();

  // Buffered edit wins, then a value already saved this session, else the loaded row.
  const checked = useSelector((state: any) => {
    const rb = state.receiverBank;
    const pending = rb?.pending?.[trackingNumberId];
    if (pending !== undefined) return pending;
    const committed = rb?.committed?.[trackingNumberId];
    if (committed !== undefined) return committed;
    return !!row?.isReceiverBank;
  });

  return (
    <input
      type="checkbox"
      style={{ transform: "scale(1.2)" }}
      checked={checked}
      disabled={!trackingNumberId}
      onChange={(e) =>
        dispatch(setPendingReceiverBank({ trackingNumberId, value: e.target.checked }))
      }
    />
  );
};
